import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 9.143c-.505 0-1.006.052-1.5.135v1.021a7.981 7.981 0 0 1 1.5-.156c.514 0 1.012.063 1.5.156V9.284A8.953 8.953 0 0 0 5 9.143Zm8 0c-.506 0-1.005.057-1.5.141v1.015a7.973 7.973 0 0 1 1.5-.156c.514 0 1.012.063 1.5.156V9.278a9.064 9.064 0 0 0-1.5-.135ZM5 6.5c-.514 0-1.012.062-1.5.15v1.016A7.46 7.46 0 0 1 5 7.5c.507 0 1.007.07 1.5.172V6.65A8.419 8.419 0 0 0 5 6.5Zm8 0a8.41 8.41 0 0 0-1.5.15v1.022A7.393 7.393 0 0 1 13 7.5a7.46 7.46 0 0 1 1.5.166V6.65A8.419 8.419 0 0 0 13 6.5ZM2 14.029V3.52a6.437 6.437 0 0 1 2.5-.509c1.212 0 2.4.346 3.438.999L8 4.049v10.3a10.045 10.045 0 0 0-3.5-.637 9.99 9.99 0 0 0-2.5.317Zm8 .32v-10.3l.062-.039a6.45 6.45 0 0 1 3.438-.999c.857 0 1.709.175 2.5.509v10.509a9.99 9.99 0 0 0-2.5-.317c-1.195 0-2.378.22-3.5.637ZM13.5 1A8.42 8.42 0 0 0 9 2.306a8.399 8.399 0 0 0-8.752-.15.51.51 0 0 0-.248.441v12.832a1 1 0 0 0 .991 1.005.968.968 0 0 0 .378-.077 8.058 8.058 0 0 1 3.131-.633c1.549 0 2.996.442 4.246 1.204a.487.487 0 0 0 .508 0 8.121 8.121 0 0 1 4.246-1.204c1.107 0 2.162.226 3.131.633a.968.968 0 0 0 .378.077A1 1 0 0 0 18 15.429V2.597a.51.51 0 0 0-.248-.441A8.396 8.396 0 0 0 13.5 1Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
